// extracted by mini-css-extract-plugin
export var buttonContainer = "_9h-1";
export var fontSizeSelect = "_9h-3";
export var formatSelect = "_9h-2";
export var formats = "_9h-4";
export var hidden = "_9h-5";
export var icon = "_9h-6";
export var select = "_9h-0";